import { Beaker, Phone, Globe, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "../../assets/axeon-chemical.svg";

export const Footer = () => {
  return (
    <footer className="bg-[#e9e9e9] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              {/* <div className="w-10 h-10 rounded-lg bg-[#00BCD4] flex items-center justify-center">
                <Beaker className="w-6 h-6 text-white" />
              </div>
              <div>
                <span className="font-bold text-xl tracking-tight">AXEON</span>
                <span className="text-[#00BCD4] text-sm block -mt-1">Water Technologies</span>
              </div> */}
              
            <div>
              <img src={logo} alt="Logo" width="300" />
            </div>
            </div>
            <p className="text-slate-800 text-sm leading-relaxed">
              Industry-leading water treatment chemical solutions for RO and NF membrane systems.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-sm tracking-wider uppercase text-slate-900 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/products" className="text-slate-700 hover:text-[#00BCD4] transition-colors">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/calculator" className="text-slate-700 hover:text-[#00BCD4] transition-colors">
                  Dosage Calculator
                </Link>
              </li>
              <li>
                <a href="https://axeonwater.com" target="_blank" rel="noopener noreferrer" className="text-slate-700 hover:text-[#00BCD4] transition-colors">
                  Main Website
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-sm tracking-wider uppercase text-slate-900 mb-4">
              Technical Support
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-slate-700">
                <Phone className="w-4 h-4 text-[#00BCD4]" />
                <span>1-800-AXEON-RO</span>
              </li>
              <li className="flex items-center gap-3 text-slate-700">
                <Mail className="w-4 h-4 text-[#00BCD4]" />
                <span>support@axeonwater.com</span>
              </li>
              <li className="flex items-center gap-3 text-slate-700">
                <Globe className="w-4 h-4 text-[#00BCD4]" />
                <a href="https://axeonwater.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#00BCD4] transition-colors">
                  www.axeonwater.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-black/10 mt-8 pt-8 text-center text-slate-600 text-sm">
          <p>&copy; {new Date().getFullYear()} AXEON Water Technologies. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
